import { render } from "./MapOrders.vue?vue&type=template&id=aab1b4d8&scoped=true"
import script from "./MapOrders.vue?vue&type=script&lang=js"
export * from "./MapOrders.vue?vue&type=script&lang=js"

import "./MapOrders.vue?vue&type=style&index=0&id=aab1b4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab1b4d8"]])

export default __exports__